/* Порождено web/scripts/gen-enums.mjs из contract/openapi.yaml.
   Правки здесь переживут ровно до следующего прогона: источник один, и он
   не тут. Файл в .gitignore и в снимок не попадает. */

export const MEMBERSHIP_ROLES = [
  'director',
  'logist',
  'dispatcher',
  'accountant',
  'mechanic',
  'driver',
] as const;

export const MEMBERSHIP_STATUSES = [
  'active',
  'closed',
] as const;

export const PERMISSIONS = [
  'company.staff.manage',
  'company.rights.manage',
  'company.fleet.manage',
  'company.fleet.repair',
  'company.docs.manage',
  'company.listings.manage',
  'company.cargo.take',
  'company.works.assign',
  'company.accounting.manage',
] as const;

export const DOCUMENT_TYPES = [
  'passport',
  'driver_license',
  'adr_certificate',
  'professional_certificate',
  'face_snapshot',
  'tachograph_card',
  'code95_card',
  'visa',
  'registration_certificate',
] as const;

export const DOCUMENT_STATUSES = [
  'pending',
  'verified',
  'rejected',
  'expired',
  'not_verified',
] as const;

export const INVITATION_STATUSES = [
  'pending',
  'accepted',
  'revoked',
  'expired',
] as const;

export const COMPANY_TYPES = [
  'transport',
  'logistics',
] as const;

export const VEHICLE_KINDS = [
  'tractor',
  'trailer',
] as const;

export const BODY_TYPES = [
  'tarpaulin',
  'refrigerator',
  'isothermal',
  'box',
  'flatbed',
  'platform',
  'lowbed',
  'mega',
  'car_carrier',
  'tipper',
  'walking_floor',
  'tank',
  'silo',
  'container_chassis',
  'bdf',
  'timber',
  'livestock',
  'coil',
  'heavy_haul',
  'extendable',
] as const;

export const REPAIR_STATES = [
  'fault_detected',
  'in_repair',
  'repaired',
  'ready',
] as const;

export const VEHICLE_STATUSES = [
  'active',
  'withdrawn',
] as const;

export const VIN_CLAIM_STATUSES = [
  'pending',
  'objected',
  'awaiting_admin',
] as const;

export const VIN_CLAIM_DIRECTIONS = [
  'outgoing',
  'incoming',
] as const;

export const WORK_STATUSES = [
  'CREATED',
  'ASSIGNED',
  'ACCEPTED',
  'AT_PICKUP',
  'AT_HANDOVER',
  'IN_TRANSIT',
  'DELIVERED',
  'COMPLETED',
  'CANCELLED',
  'ARCHIVED',
] as const;

export const PEREGON_VEHICLE_KINDS = [
  'tractor',
  'tractor_with_trailer',
  'car',
] as const;

export const LISTING_STATUSES = [
  'OPEN',
  'TAKEN',
  'CLOSED',
  'CANCELLED',
  'PENDING_REVIEW',
  'REJECTED',
] as const;

export const CARGO_OFFER_STATUSES = [
  'PENDING',
  'APPROVED',
  'CONFIRMED',
  'REJECTED',
  'WITHDRAWN',
  'EXPIRED',
  'SUPERSEDED',
] as const;

export const CARGO_SLOT_STATUSES = [
  'OPEN',
  'RESERVED',
  'TAKEN',
  'CANCELLED',
] as const;

export const CURRENCIES = [
  'USD',
  'UZS',
  'EUR',
] as const;

export const PAYMENT_METHODS = [
  'cash',
  'bank_transfer',
] as const;

export const PAYMENT_MOMENTS = [
  'prepayment',
  'on_unloading',
  'deferred',
] as const;

export const LOADING_TYPES = [
  'rear',
  'side',
  'top',
  'full_uncover',
] as const;

export const CARGO_BODY_PARAMETERS = [
  'length_m',
  'width_m',
  'height_m',
  'volume_m3',
  'capacity_t',
  'loading_type',
  'temperature',
  'cars_capacity',
] as const;

export const GENDERS = [
  'male',
  'female',
] as const;

export const EXPENSE_CATEGORIES = [
  'diesel',
  'parking',
  'toll',
  'service',
  'other',
] as const;
